import { deepClone } from 'Utils/functions'

const emptyDay = {
  label: '',
  isEnabled: false,
  limit: ''
}

const emptyInterval = {
  isEnabled: false,
  startTime: '',
  endTime: '',
  blockInterval: '',
  days: [
    deepClone(emptyDay)
  ]
}

const emptyDeliveryCost = {
  orderCostFrom: '',
  orderCostTo: '',
  deliveryCost: ''
}

const emptyPoint = {
  x: '',
  y: ''
}

const emptyZone = {
  id: '',
  zone: {
    name: '',
    description: '',
    points: [
      deepClone(emptyPoint)
    ]
  },
  intervals: [
    deepClone(emptyInterval)
  ],
  deliveryCosts: [
    deepClone(emptyDeliveryCost)
  ]
}

const emptyStore = {
  id: '',
  regionId: '',
  address: '',
  zones: [
    deepClone(emptyZone)
  ],
  pickup: {
    cancelInterval: '',
    intervals: [
      deepClone(emptyInterval)
    ]
  },
  settings: {
    deliveryHorizont: '',
    height: '',
    width: '',
    length: '',
    volume: '',
    weight: ''
  }
}

export default [
  {
    id: 1,
    regionId: 20,
    address: 'первый',
    zones: [

    ],
    pickup: {
      cancelInterval: '',
      intervals: [

      ]
    },
    settings: {
      deliveryHorizont: '',
      height: '',
      width: '',
      length: '',
      volume: '',
      weight: ''
    }
  },
  {
    id: 2,
    regionId: 20,
    address: 'второй',
    zones: [

    ],
    pickup: {
      cancelInterval: '',
      intervals: [

      ]
    },
    settings: {
      deliveryHorizont: '',
      height: '',
      width: '',
      length: '',
      volume: '',
      weight: ''
    }
  },
  {
    id: 3,
    regionId: 20,
    address: 'третий',
    zones: [
      {
        id: 1,
        name: 'Первая зона'
      },
      {
        id: 2,
        name: 'Вторая зона'
      }
    ],
    pickup: {
      cancelInterval: '2',
      intervals: [
        {
          isEnabled: true,
          from: '10:00',
          to: '12:00',
          blockInterval: '8',
          days: [
            {
              label: 'Пн',
              isEnabled: true,
              limit: '3'
            },
            {
              label: 'Вт',
              isEnabled: true,
              limit: '3'
            },
            {
              label: 'Ср',
              isEnabled: false,
              limit: '4'
            },
            {
              label: 'Чт',
              isEnabled: false,
              limit: ''
            },
            {
              label: 'Пт',
              isEnabled: false,
              limit: '2'
            },
            {
              label: 'Сб',
              isEnabled: true,
              limit: '2'
            },
            {
              label: 'Вс',
              isEnabled: true,
              limit: '3'
            }
          ]
        },
        {
          isEnabled: false,
          from: '12:00',
          to: '14:00',
          blockInterval: '12',
          days: [
            {
              label: 'Пн',
              isEnabled: true,
              limit: '3'
            },
            {
              label: 'Вт',
              isEnabled: false,
              limit: '3'
            },
            {
              label: 'Ср',
              isEnabled: true,
              limit: '3'
            },
            {
              label: 'Чт',
              isEnabled: true,
              limit: ''
            },
            {
              label: 'Пт',
              isEnabled: false,
              limit: ''
            },
            {
              label: 'Сб',
              isEnabled: false,
              limit: ''
            },
            {
              label: 'Вс',
              isEnabled: false,
              limit: ''
            }
          ]
        }
      ]
    },
    settings: {
      deliveryHorizont: '3',
      height: '150',
      width: '150',
      length: '300',
      volume: '40',
      weight: '600'
    }
  },
  deepClone(emptyStore)
]
